import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-hydrotherapist-hero.png`}
        alt="Dog having a message therapy session"
        height={2000}
        width={2000}
      />

      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>
                Manage repeat clients and avoid missed appointments with booking software for{' '}
                <strong> pet massage therapists</strong>
              </h1>
            </TextWithHighlight>
            <p>
              Unlock admin-reducing features like online bookings, deposits, and client tracking with our{' '}
              <strong>massage therapy scheduling </strong>
              tool for pets.
            </p>

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Sign up for free</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          <Image
            src={`${VITE_CDN_BASE_URL}/images/image-hydrotherapist-hero.png`}
            alt="Dog being training with a session booked through Pata booking platform"
            height={2000}
            width={2000}
          />
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
